export const statusColor = (status) => {
  switch (status) {
    case 'PENDING':
      return '#F0AD4E'
    case 'APPROVED':
      return '#5CB85C'
    case 'REJECTED':
      return '#D44B49'
    case 'REJECTED BY HR':
      return '#D44B49'
    case 'UNSUBMITTED':
      return '#BBBBBB'
    case 'NONSUBMIT':
      return '#BBBBBB'
    case 'CANCEL':
      return '#D44B49'
    default:
      return '#BBBBBB'
  }
}

export const leaveColor = (status) => {
  switch (status) {
    case 'HOLIDAY':
      return '#7B7B7B'
    case 'WEEKEND':
      return '#EBEBEB'
    case 'FULLDAY':
      return '#222222'
    case 'COMPENSATE':
      return '#0071BD'
    case 'AM':
      return '#FBFF7A'
    case 'PM':
      return '#FBFF7A'
    default:
      return null
  }
}

export const approveStatus = (status) => {
  switch (status) {
    case 'NONSUBMIT':
      return 'UNSUBMITTED'
    case 'CANCEL':
      return 'REJECTED BY HR'
    default:
      return status
  }
}

export const customStyles = {
  control: (base, state) => ({
    ...base,
    height: 30,
    background: !state.isDisabled ? "#FFFFFF" : '#e9ecef',
    minHeight: 30,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    width: 15,
    padding: 0,
  }),
}

export const invalidStyles = {
  control: (base, state) => ({
    ...base,
    border: !state.isFocused ? '1px solid #dc3545' : '',
    background: "#FFFFFF",
    ...base,
    height: 30,
    minHeight: 30,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    width: 15,
    padding: 0,
  }),
}



// WEBPACK FOOTER //
// ./src/components/timesheet/helpers/color.js